export class OrganizationDataForm {
    organizationId: number;
    organizationName: string;
    addressLineOne: string;
    addressLineTwo: string;
    city: string;
    state: string;
    countryName: string;
    zipCode: string;
    webSite: string;
    phoneNumber: number;

}